module.exports = __webpack_public_path__ + "static/media/portfolio_background-01.488b3985.svg";